export default __webpack_public_path__ + "static/media/V2-CARROUSEL_5.78665266.jpg";